import React, { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { getSize } from 'helpers/utils';
import { Button, Card, Dropdown } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';
import Flex from 'components/common/Flex';
import cloudUpload from 'assets/img/icons/cloud-upload.svg';
import CardDropdown from 'components/common/CardDropdown';

const ArticleUpload = () => {
 const { setValue, watch } = useFormContext();
 const images = watch('images');
 const [files, setFiles] = useState(images ?? []);

 const { getRootProps, getInputProps } = useDropzone({
  accept: { 'image/*': ['.jpeg', '.png', '.jpg'] },
  onDrop: async acceptedFiles => {
   setValue('images', [...files, ...acceptedFiles.map(file => Object.assign(file, { preview: URL.createObjectURL(file) }))]);
  }
 });

 useEffect(() => {
  setFiles(images ?? []);
 }, [images]);

 const handleRemove = index =>
  setValue(
   'images',
   files.filter((_, i) => i !== index)
  );

 return (
  <Card className="mb-3">
   <Card.Header as="h6" className="bg-body-tertiary">
    Añadir imágenes
   </Card.Header>
   <Card.Body>
    <div {...getRootProps({ className: 'dropzone-area py-3' })}>
     <input name="uploadedFiles" className="images" {...getInputProps()} />
     <div className="fs-10">
      <img src={cloudUpload} alt="" width={25} className="me-2" />
      <span className="d-none d-lg-inline">
       Arrastra tu imagen aquí
       <br />
       o,{' '}
      </span>
      <Button variant="link" size="sm" className="p-0 fs-10">
       Seleccionalas
      </Button>
     </div>
    </div>
    <div>
     {files.map((file, i) => (
      <Flex alignItems="center" className="py-3 border-bottom btn-reveal-trigger" key={i}>
       <img className="rounded" width={40} height={40} src={file?.preview ?? file} alt={file?.path} />

       <Flex justifyContent="between" alignItems="center" className="ms-3 flex-1">
        <div>
         <h5 className="mb-0 fs-0">{file?.path ?? 'imagen web'}</h5>
         <small className="mb-0 text-400 line-height-1">
          <strong>{file?.size ? getSize(file.size) : 'sin info'}</strong>
         </small>
        </div>
       </Flex>
       <CardDropdown>
        <div className="py-2">
         <Dropdown.Item className="text-danger" onClick={() => handleRemove(i)}>
          Remove
         </Dropdown.Item>
        </div>
       </CardDropdown>
      </Flex>
     ))}
    </div>
   </Card.Body>
  </Card>
 );
};

export default ArticleUpload;
